import script from "./PdTile.vue?vue&type=script&setup=true&lang=js"
export * from "./PdTile.vue?vue&type=script&setup=true&lang=js"

import "./PdTile.vue?vue&type=style&index=0&id=08fa342c&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fa342c"]])

export default __exports__